/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addProjectComment = /* GraphQL */ `mutation AddProjectComment($input: AddProjectCommentInput!) {
  addProjectComment(input: $input) {
    commentId
    errorCode
    errors
    success
  }
}
` as GeneratedMutation<APITypes.AddProjectCommentMutationVariables, APITypes.AddProjectCommentMutation>;
export const createAnnouncement = /* GraphQL */ `mutation CreateAnnouncement($input: AnnouncementInput) {
  createAnnouncement(input: $input) {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedMutation<APITypes.CreateAnnouncementMutationVariables, APITypes.CreateAnnouncementMutation>;
export const createApplication = /* GraphQL */ `mutation CreateApplication($input: ApplicationInput) {
  createApplication(input: $input) {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    mcpPath
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
    urlName
  }
}
` as GeneratedMutation<APITypes.CreateApplicationMutationVariables, APITypes.CreateApplicationMutation>;
export const createFeedback = /* GraphQL */ `mutation CreateFeedback($input: FeedbackInput) {
  createFeedback(input: $input) {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedMutation<APITypes.CreateFeedbackMutationVariables, APITypes.CreateFeedbackMutation>;
export const createGeneralContent = /* GraphQL */ `mutation CreateGeneralContent($input: GeneralContentInput) {
  createGeneralContent(input: $input) {
    content
    id
    name
  }
}
` as GeneratedMutation<APITypes.CreateGeneralContentMutationVariables, APITypes.CreateGeneralContentMutation>;
export const createHolidaysByYear = /* GraphQL */ `mutation CreateHolidaysByYear($input: [HolidayInput!]!) {
  createHolidaysByYear(input: $input) {
    country
    createdAt
    daysClosed
    isActive
    reason
    updatedAt
    week
    year
  }
}
` as GeneratedMutation<APITypes.CreateHolidaysByYearMutationVariables, APITypes.CreateHolidaysByYearMutation>;
export const createIntake = /* GraphQL */ `mutation CreateIntake($input: CreateIntakeInput!) {
  createIntake(input: $input) {
    errorCode
    errors
    success
  }
}
` as GeneratedMutation<APITypes.CreateIntakeMutationVariables, APITypes.CreateIntakeMutation>;
export const createKingpinGoal = /* GraphQL */ `mutation CreateKingpinGoal($input: KingpinGoalInput!) {
  createKingpinGoal(input: $input) {
    createdAt
    goalId
    isActive
    pocAliases
    tier
    tobiasDirectAlias
    updatedAt
  }
}
` as GeneratedMutation<APITypes.CreateKingpinGoalMutationVariables, APITypes.CreateKingpinGoalMutation>;
export const createMcpConfig = /* GraphQL */ `mutation CreateMcpConfig($input: McpConfigInput!) {
  createMcpConfig(input: $input) {
    category
    contacts {
      alias
      role
    }
    createdAt
    createdBy
    description
    features {
      description
      icon
      title
    }
    id
    isFeatured
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    name
    resources {
      label
      type
      url
    }
    terminalCommands {
      command
      method
      os
    }
    toolGroups {
      category
      tools {
        description
        name
      }
    }
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.CreateMcpConfigMutationVariables, APITypes.CreateMcpConfigMutation>;
export const createOrUpdateApplicationFavorites = /* GraphQL */ `mutation CreateOrUpdateApplicationFavorites($input: FavoriteInput) {
  createOrUpdateApplicationFavorites(input: $input) {
    applicationId
    id
    userAlias
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateApplicationFavoritesMutationVariables, APITypes.CreateOrUpdateApplicationFavoritesMutation>;
export const createOrUpdateLabels = /* GraphQL */ `mutation CreateOrUpdateLabels($input: [LabelInput]) {
  createOrUpdateLabels(input: $input) {
    id
    label
    labelType
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateLabelsMutationVariables, APITypes.CreateOrUpdateLabelsMutation>;
export const createOrUpdateMapping = /* GraphQL */ `mutation CreateOrUpdateMapping($input: [MappingInput], $table_name: String) {
  createOrUpdateMapping(input: $input, table_name: $table_name) {
    numberOfRecordsUpdated
  }
}
` as GeneratedMutation<APITypes.CreateOrUpdateMappingMutationVariables, APITypes.CreateOrUpdateMappingMutation>;
export const createProjectsByLeader = /* GraphQL */ `mutation CreateProjectsByLeader($input: [ProjectInput!]!) {
  createProjectsByLeader(input: $input) {
    additionalLeaders
    createdAt
    isActive
    isGlobal
    lead
    projectId
    projectName
    targetFte
    type
    updatedAt
  }
}
` as GeneratedMutation<APITypes.CreateProjectsByLeaderMutationVariables, APITypes.CreateProjectsByLeaderMutation>;
export const deleteApplication = /* GraphQL */ `mutation DeleteApplication($input: [ApplicationInput]) {
  deleteApplication(input: $input)
}
` as GeneratedMutation<APITypes.DeleteApplicationMutationVariables, APITypes.DeleteApplicationMutation>;
export const deleteFinanceCalendarEvent = /* GraphQL */ `mutation DeleteFinanceCalendarEvent($eventId: String!) {
  deleteFinanceCalendarEvent(eventId: $eventId)
}
` as GeneratedMutation<APITypes.DeleteFinanceCalendarEventMutationVariables, APITypes.DeleteFinanceCalendarEventMutation>;
export const deleteKingpinGoal = /* GraphQL */ `mutation DeleteKingpinGoal($goalId: String!) {
  deleteKingpinGoal(goalId: $goalId) {
    createdAt
    goalId
    isActive
    pocAliases
    tier
    tobiasDirectAlias
    updatedAt
  }
}
` as GeneratedMutation<APITypes.DeleteKingpinGoalMutationVariables, APITypes.DeleteKingpinGoalMutation>;
export const deleteMcpConfig = /* GraphQL */ `mutation DeleteMcpConfig($id: String!) {
  deleteMcpConfig(id: $id)
}
` as GeneratedMutation<APITypes.DeleteMcpConfigMutationVariables, APITypes.DeleteMcpConfigMutation>;
export const deleteProjectComment = /* GraphQL */ `mutation DeleteProjectComment($input: DeleteProjectCommentInput!) {
  deleteProjectComment(input: $input) {
    commentId
    errorCode
    errors
    success
  }
}
` as GeneratedMutation<APITypes.DeleteProjectCommentMutationVariables, APITypes.DeleteProjectCommentMutation>;
export const editProjectComment = /* GraphQL */ `mutation EditProjectComment($input: EditProjectCommentInput!) {
  editProjectComment(input: $input) {
    commentId
    errorCode
    errors
    success
  }
}
` as GeneratedMutation<APITypes.EditProjectCommentMutationVariables, APITypes.EditProjectCommentMutation>;
export const putFinanceCalendarEvents = /* GraphQL */ `mutation PutFinanceCalendarEvents($events: [FinanceCalendarEventInput!]!) {
  putFinanceCalendarEvents(events: $events) {
    dateTime
    description
    event
    eventId
    scenario
    source
  }
}
` as GeneratedMutation<APITypes.PutFinanceCalendarEventsMutationVariables, APITypes.PutFinanceCalendarEventsMutation>;
export const setVoteCycleState = /* GraphQL */ `mutation SetVoteCycleState($input: VoteCycleStateInput!) {
  setVoteCycleState(input: $input) {
    cycleId
    errorCode
    errors
    status
    success
  }
}
` as GeneratedMutation<APITypes.SetVoteCycleStateMutationVariables, APITypes.SetVoteCycleStateMutation>;
export const updateAnnouncement = /* GraphQL */ `mutation UpdateAnnouncement($input: AnnouncementInput) {
  updateAnnouncement(input: $input) {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedMutation<APITypes.UpdateAnnouncementMutationVariables, APITypes.UpdateAnnouncementMutation>;
export const updateApplication = /* GraphQL */ `mutation UpdateApplication($input: ApplicationInput) {
  updateApplication(input: $input) {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    mcpPath
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
    urlName
  }
}
` as GeneratedMutation<APITypes.UpdateApplicationMutationVariables, APITypes.UpdateApplicationMutation>;
export const updateDasFinSumFeedback = /* GraphQL */ `mutation UpdateDasFinSumFeedback($input: DasFinSumFeedbackInput) {
  updateDasFinSumFeedback(input: $input)
}
` as GeneratedMutation<APITypes.UpdateDasFinSumFeedbackMutationVariables, APITypes.UpdateDasFinSumFeedbackMutation>;
export const updateFeedback = /* GraphQL */ `mutation UpdateFeedback($input: FeedbackInput) {
  updateFeedback(input: $input) {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedMutation<APITypes.UpdateFeedbackMutationVariables, APITypes.UpdateFeedbackMutation>;
export const updateGeneralContent = /* GraphQL */ `mutation UpdateGeneralContent($input: [GeneralContentInput]) {
  updateGeneralContent(input: $input) {
    content
    id
    name
  }
}
` as GeneratedMutation<APITypes.UpdateGeneralContentMutationVariables, APITypes.UpdateGeneralContentMutation>;
export const updateHolidaysByYear = /* GraphQL */ `mutation UpdateHolidaysByYear($input: [HolidayUpdateInput!]!) {
  updateHolidaysByYear(input: $input) {
    country
    createdAt
    daysClosed
    isActive
    reason
    updatedAt
    week
    year
  }
}
` as GeneratedMutation<APITypes.UpdateHolidaysByYearMutationVariables, APITypes.UpdateHolidaysByYearMutation>;
export const updateHomePageContent = /* GraphQL */ `mutation UpdateHomePageContent($input: HomePageContentInput) {
  updateHomePageContent(input: $input) {
    applicationBanner {
      action {
        label
        url
      }
      bannerType
      content
      dismissible
      header
      isEnabled
    }
    contactsWidgetContacts {
      contactId
      groupName
      otherContacts {
        contactAlias
        contactName
      }
      primaryContact {
        contactAlias
        contactName
      }
      simLinks {
        name
        url
      }
      slackChannels {
        name
        url
      }
    }
    hasWelcomeContent
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    welcomeContentDetails {
      description
      displayText
      id
      link
      pointOfContact
    }
    welcomeTitle
  }
}
` as GeneratedMutation<APITypes.UpdateHomePageContentMutationVariables, APITypes.UpdateHomePageContentMutation>;
export const updateIntake = /* GraphQL */ `mutation UpdateIntake($input: UpdateIntakeInput!) {
  updateIntake(input: $input) {
    errorCode
    errors
    success
  }
}
` as GeneratedMutation<APITypes.UpdateIntakeMutationVariables, APITypes.UpdateIntakeMutation>;
export const updateKingpinGoal = /* GraphQL */ `mutation UpdateKingpinGoal($input: KingpinGoalInput!) {
  updateKingpinGoal(input: $input) {
    createdAt
    goalId
    isActive
    pocAliases
    tier
    tobiasDirectAlias
    updatedAt
  }
}
` as GeneratedMutation<APITypes.UpdateKingpinGoalMutationVariables, APITypes.UpdateKingpinGoalMutation>;
export const updateMcpConfig = /* GraphQL */ `mutation UpdateMcpConfig($input: McpConfigInput!) {
  updateMcpConfig(input: $input) {
    category
    contacts {
      alias
      role
    }
    createdAt
    createdBy
    description
    features {
      description
      icon
      title
    }
    id
    isFeatured
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    name
    resources {
      label
      type
      url
    }
    terminalCommands {
      command
      method
      os
    }
    toolGroups {
      category
      tools {
        description
        name
      }
    }
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.UpdateMcpConfigMutationVariables, APITypes.UpdateMcpConfigMutation>;
export const updateProjectsByLeader = /* GraphQL */ `mutation UpdateProjectsByLeader($input: [ProjectUpdateInput!]!) {
  updateProjectsByLeader(input: $input) {
    additionalLeaders
    createdAt
    isActive
    isGlobal
    lead
    projectId
    projectName
    targetFte
    type
    updatedAt
  }
}
` as GeneratedMutation<APITypes.UpdateProjectsByLeaderMutationVariables, APITypes.UpdateProjectsByLeaderMutation>;
export const updateTeamPageContent = /* GraphQL */ `mutation UpdateTeamPageContent($input: TeamPageContentInput) {
  updateTeamPageContent(input: $input) {
    enableTeamInfoTabs
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    sidePanelDetails {
      customSidePanelWidgets {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
      keyContacts {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      officeHours {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      supportLinks {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
    }
    teams {
      id
      teamIntroductionVideoUrl
      teamName
      teamOverView
      teamWelcomeDetails {
        description
        displayText
        id
        link
        pointOfContact
      }
    }
  }
}
` as GeneratedMutation<APITypes.UpdateTeamPageContentMutationVariables, APITypes.UpdateTeamPageContentMutation>;
export const upsertGlobalProjects = /* GraphQL */ `mutation UpsertGlobalProjects($input: [GlobalProjectInput!]!) {
  upsertGlobalProjects(input: $input) {
    additionalLeaders
    createdAt
    isActive
    isGlobal
    lead
    projectId
    projectName
    targetFte
    type
    updatedAt
  }
}
` as GeneratedMutation<APITypes.UpsertGlobalProjectsMutationVariables, APITypes.UpsertGlobalProjectsMutation>;
export const upsertHeadcountDetails = /* GraphQL */ `mutation UpsertHeadcountDetails($input: HeadcountDetailsInput!) {
  upsertHeadcountDetails(input: $input) {
    details {
      name
      value
    }
    key
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.UpsertHeadcountDetailsMutationVariables, APITypes.UpsertHeadcountDetailsMutation>;
export const upsertHeadcountHighlight = /* GraphQL */ `mutation UpsertHeadcountHighlight($input: HeadcountHighlightInput!) {
  upsertHeadcountHighlight(input: $input) {
    highlighted
    key
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.UpsertHeadcountHighlightMutationVariables, APITypes.UpsertHeadcountHighlightMutation>;
export const upsertHeadcountNote = /* GraphQL */ `mutation UpsertHeadcountNote($input: HeadcountNoteInput!) {
  upsertHeadcountNote(input: $input) {
    author
    createdAt
    key
    noteId
    text
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.UpsertHeadcountNoteMutationVariables, APITypes.UpsertHeadcountNoteMutation>;
export const upsertHeadcountTags = /* GraphQL */ `mutation UpsertHeadcountTags($input: HeadcountTagsInput!) {
  upsertHeadcountTags(input: $input) {
    key
    tags
    updatedAt
    updatedBy
  }
}
` as GeneratedMutation<APITypes.UpsertHeadcountTagsMutationVariables, APITypes.UpsertHeadcountTagsMutation>;
export const upsertPeopleByLeader = /* GraphQL */ `mutation UpsertPeopleByLeader($input: [PersonInput!]!) {
  upsertPeopleByLeader(input: $input) {
    alias
    createdAt
    isActive
    level
    name
    reportsTo
    title
    updatedAt
  }
}
` as GeneratedMutation<APITypes.UpsertPeopleByLeaderMutationVariables, APITypes.UpsertPeopleByLeaderMutation>;
export const upsertProjectDetailsByAlias = /* GraphQL */ `mutation UpsertProjectDetailsByAlias($input: [ProjectDetailInput!]!) {
  upsertProjectDetailsByAlias(input: $input) {
    alias
    allocations {
      fte
      percent
      projectId
    }
    confirmed
    createdAt
    note
    updatedAt
    week
    year
  }
}
` as GeneratedMutation<APITypes.UpsertProjectDetailsByAliasMutationVariables, APITypes.UpsertProjectDetailsByAliasMutation>;
export const upsertVoteCycle = /* GraphQL */ `mutation UpsertVoteCycle($input: VoteCycleInput!) {
  upsertVoteCycle(input: $input) {
    cycleId
    errorCode
    errors
    status
    success
  }
}
` as GeneratedMutation<APITypes.UpsertVoteCycleMutationVariables, APITypes.UpsertVoteCycleMutation>;
export const upsertWeekConfigByLeader = /* GraphQL */ `mutation UpsertWeekConfigByLeader($input: [WeekConfigInput!]!) {
  upsertWeekConfigByLeader(input: $input) {
    createdAt
    isActive
    leaderAlias
    updatedAt
    updatedBy
    week
    year
  }
}
` as GeneratedMutation<APITypes.UpsertWeekConfigByLeaderMutationVariables, APITypes.UpsertWeekConfigByLeaderMutation>;
export const voteProject = /* GraphQL */ `mutation VoteProject($input: ProjectVoteInput!) {
  voteProject(input: $input) {
    budget
    cycleId
    errorCode
    errors
    hasMyNotRequired
    hasMyVote
    notRequiredCount
    projectGid
    success
    voteCount
    votesRemaining
    votesUsed
  }
}
` as GeneratedMutation<APITypes.VoteProjectMutationVariables, APITypes.VoteProjectMutation>;
